var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selected_file)?_c('div',{staticClass:"text-secondary small sticky-top bg-apple-gray-5 "},[_vm._v("event "+_vm._s(_vm.selected_index + 1)+" of "+_vm._s(_vm.total_events)+" in "+_vm._s(_vm.selected_file.filename)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }